module.exports = __webpack_public_path__ + "img/aliyun_disk.288947b5.svg";